import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/catalogQuickAtb/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showCatalogQuickAtbSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showCatalogQuickAtbSelector };
